


import { Component, Vue, Watch } from 'vue-property-decorator'

@Component({
  components: {},
  computed: {},
})
export default class DateRangeMixin extends Vue {
  layoutPlotly = {
    barmode: 'stack',
    title: '',
    margin: {
      l: 100,
      r: 20,
    },
    paper_bgcolor: '#F5F5F5',
    plot_bgcolor: '#F5F5F5',
  }

  dataTableAnalysis: any[] = []

  get columns(): any {
    return []
  }

  setChartConfig() {
    this.layoutPlotly.title = this.$t('label.analysis_chart_title') as string
  }

  get dataPlotly() {
    if (!this.dataTableAnalysis.length || !this.columns.length) {
      return []
    }

    const data: any = []
    const locations: string[] = []
    for (const item of this.dataTableAnalysis) {
      locations.push(item.location)
    }

    for (const column of this.columns) {
      if (column.field === 'location' || column.field === 'sum') {
        continue
      }

      const dataVal: number[] = []
      for (const item of this.dataTableAnalysis) {
        dataVal.push(item[column.field])
      }

      if (0 === dataVal.reduce((acc, cur) => acc + cur)) {
        continue
      }

      data.push({
        y: locations,
        x: dataVal,
        text: column.label,
        textposition: 'auto',
        hoverinfo: 'none',
        marker: {
          color: column.color,
          line: {
            color: 'black',
            width: 1.0,
          },
        },
        name: column.label,
        type: 'bar',
        orientation: 'h',
      })
    }

    return data
  }
}
